import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class TabService {
  // ***** SG-7344 START *****
  private tabCountKey = 'tabCount'; // Key to store tab count in localStorage
  public tabCount$: BehaviorSubject<number>;
  currentPath = '';

  constructor(private location: Location) {
    this.tabCount$ = new BehaviorSubject<number>(this.getTabCount());
    this.currentPath = this.location.path();

    if (!this.currentPath.toString().includes('live-session/')) {
      // Listen to storage event for changes in other tabs
      window.addEventListener('storage', this.syncTabs.bind(this));
      
      // Increment the tab count when a new tab is opened
      this.incrementTabCount();
  
      // Listen to the window's beforeunload event to decrease count when a tab is closed
      window.addEventListener('beforeunload', this.decrementTabCount.bind(this));      
    }
  }

  // Increment the tab count
  private incrementTabCount(): void {
    const tabCount = this.getTabCount() + 1;
    localStorage.setItem(this.tabCountKey, tabCount.toString());
    this.tabCount$.next(tabCount);
  }

  // Decrement the tab count when a tab is closed
  private decrementTabCount(): void {
    const tabCount = Math.max(this.getTabCount() - 1, 0);
    localStorage.setItem(this.tabCountKey, tabCount.toString());
    this.tabCount$.next(tabCount);
  }

  // Get the current tab count from localStorage
  private getTabCount(): number {
    return Number(localStorage.getItem(this.tabCountKey)) || 0;
  }

  // Sync tabs when the storage event occurs
  private syncTabs(event: StorageEvent): void {
    if (event.key === this.tabCountKey) {
      const newTabCount = this.getTabCount();
      this.tabCount$.next(newTabCount);
    }
  }
  // ***** SG-7344 END *****
}
